import React, { ReactNode } from 'react'
import { Box, Grid, SxProps, Theme } from '@mui/material'

const fieldGroupSx: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius}px`,
  px: 1.5,
  py: 0.5,
  height: '100%',
})

export const fieldGroupItemSize = { xs: 12, md: 6 } as const

export interface FieldGroupProps {
  /** Grid column span (out of 12) from the `md` breakpoint upward. */
  size: number
  children: ReactNode
  spacing?: number
  columnSpacing?: number
}

export const FieldGroup: React.FC<FieldGroupProps> = ({ size, children, spacing = 1, columnSpacing = 1.5 }) => (
  <Grid size={{ xs: 12, md: size }}>
    <Box sx={fieldGroupSx}>
      <Grid container spacing={spacing} columnSpacing={columnSpacing}>
        {children}
      </Grid>
    </Box>
  </Grid>
)
